import { map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
// ---- external imports -----

import { uiActions } from '~/store';
import { LEVEL_FAILED } from '~/store/level/actionTypes';
import { MAIN_SCREEN_MODALS } from '~/lib/constants';
// ---- internal imports ----


const onLevelFailedEpic = (action$) => action$.pipe(
	ofType(LEVEL_FAILED),
	map(() => uiActions.changeActiveModal(MAIN_SCREEN_MODALS.MISSION_FAILED)),
);


export default onLevelFailedEpic;
